import { useMediaQuery } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreInformation, useUser } from '../../hooks';
import { Typography } from '../../stories/atoms';
import { ColumnFlexContainer } from '../../stories/atoms/containerV2/ContainerV2';
import { Page } from '../../stories/organisms';
import { muiTheme } from '../../theme';
import { salesAnalysisTranslation } from '../../translations/salesAnalysis';
import { usePageEventTracker } from '../../hooks/usePageEventTracker';
import { StoreDetailsModal } from './storeDetailsModal/StoreDetailsModal';
import { StoresView } from './storesView/StoresView';

export const AreaStoresListPage: FC<unknown> = observer(() => {
  usePageEventTracker('store_list');

  const { t } = useTranslation();
  const isTablet = useMediaQuery(muiTheme.breakpoints.down('tabletLandscape'));
  const {
    get: { storesDetails },
  } = useUser();
  const { areaName } = useStoreInformation();
  const [selectedModalStore, setSelectedModalStore] = useState<string | null>(null);

  const filteredStoresByArea = storesDetails.filter((store) => store.area === areaName);

  const handleStoreDetails = (storeId: string) => {
    setSelectedModalStore(storeId);
  };

  return (
    <Page
      body={
        <>
          {!!storesDetails.length && selectedModalStore && (
            <StoreDetailsModal
              isOpen={!!selectedModalStore}
              storeId={selectedModalStore}
              onClose={() => {
                setSelectedModalStore(null);
              }}
            />
          )}
          <ColumnFlexContainer
            padding={isTablet ? [4, 4, 0, 4] : [4, 8, 0, 8]}
            data-testid="area-result-page-wrapper"
            height="100%"
          >
            <Typography type={isTablet ? 'h4' : 'h3'} overflow="inherit">
              {areaName} - ({filteredStoresByArea.length}{' '}
              {t(salesAnalysisTranslation.stores.key, salesAnalysisTranslation.stores.defaultValue)})
            </Typography>
            <StoresView
              stores={filteredStoresByArea}
              showStoreDetails={(storeId) => handleStoreDetails(storeId)}
            />
          </ColumnFlexContainer>
        </>
      }
    />
  );
});
